/**
 * 页面元信息注册表（全局唯一数据源）
 * 统一维护「路由路径 -> 页面标识」的映射，供导航跳转、埋点、来源页归因复用。
 * 新增页面时只需在此追加一条配置。
 *
 * pageName:    数据采集中的页面 / 来源页统一标识
 * btnName: 头部导航点击埋点标识
 */
export const PAGE_META = {
  '/home': { pageName: 'edu_web_home_page', btnName: 'head_home' },
  '/price': { pageName: 'edu_web_price_page', btnName: 'head_price' },
  '/help': { pageName: 'edu_web_help_page', btnName: 'head_help' },
  '/case': {
    pageName: 'edu_web_customer_case_page',
    btnName: 'head_customer_case',
  },
  '/download': { pageName: 'load_page', btnName: 'head_down_load' },
  '/k12-ai-teaching': {
    pageName: 'edu_web_solution_k12',
    btnName: 'head_k12',
  },
  '/college-talent-training': {
    pageName: 'edu_web_solution_higher_edu',
    btnName: 'head_higher_edu',
  },
};

// 根据路径（含子路径）匹配页面标识 pageId，未命中返回空串
export const getPageNameByPath = (pathname = '') => {
  const entry = Object.entries(PAGE_META).find(([path]) =>
    pathname.includes(path)
  );
  return entry ? entry[1].pageName : '';
};

// 根据精确路由路径获取埋点标识，未命中返回空串
export const getBtnNameByPath = (path) => PAGE_META[path]?.btnName || '';
